import { createContext } from 'react'

export const DocumentPreviewContext = createContext(null)
